const Logo = () => (
    <div className="left_header">
        <span className="logo"> Logo </span>
    </div>
)
export default Logo